import * as React from "react";

export interface WizardStepProps {
    id: string;
    component: React.ReactElement;
    title: string;
    hasError?: boolean;
    additionalProps?: any;
}

export const WizardStep = (props: WizardStepProps) => {
    const Component = () =>
        React.cloneElement(props.component, {
            additionalProps: props.additionalProps,
            key: props.id,
        });

    return <Component />;
};
